<template>
  <div class="card-user-small">
    <div class="info-block">
      <!-- プロフィール画像 -->
      <b-card-img
        v-bind:src="profileImageUrl"
        class="profile-icon"
        crossorigin="use-credentials"
      />
      <!-- ユーザー名。仕様(cluster.png)により12文字で省略する -->
      <span class="user-name">
        {{ displayName }}
      </span>
    </div>
    <div class="detail-block">
      <!-- 詳細リンク -->
      <span
        class="detail-link"
        v-on:click="$_onClickDetail"
        v-t="'appCardUserSmall.detail'"
      />
    </div>
    <!-- 表示項目の値(2段目) -->
    <user-additional-item-inline
      v-if="itemText"
      class="item-block"
      v-bind:text="itemText"
      v-bind:icon="itemIcon"
      v-bind:dot-color="itemDotColor"
    />
  </div>
</template>

<script>
import { RestApiClient } from 'ifield-core-components'
import UserAdditionalItemInline from '@/components/member/AppUserAdditionalItemInline.vue'
import { MAX_CLUSTER_NAME_LENGTH, truncate } from '@/js/util/UserLabelUtil.js'

export default {
  name: 'AppCardSmallUser',
  components: {
    'user-additional-item-inline': UserAdditionalItemInline,
  },
  props: {
    /**
     * ユーザーID
     */
    id: {
      type: Number,
      default: null,
      required: true,
    },
    /**
     * ユーザー名
     */
    name: {
      type: String,
      default: '',
    },
    /**
     * 表示項目の値(2段目)
     */
    itemText: {
      type: String,
      default: '',
    },
    /**
     * 表示項目のアイコン名
     */
    itemIcon: {
      type: String,
      default: null,
    },
    /**
     * 値の後ろに出す色（ステイタスの色）
     */
    itemDotColor: {
      type: String,
      default: null,
    },
  },
  computed: {
    /**
     * 表示するユーザー名
     * 仕様(cluster.png): 最大12文字。超えたら...で省略する(マウスホバーは不要)
     * @type {String}
     */
    displayName: function () {
      return truncate(this.name, MAX_CLUSTER_NAME_LENGTH)
    },
    /**
     * プロフィール画像のURL
     * @type {String}
     */
    profileImageUrl: function () {
      // ダウンロードファイルAPI
      const url = RestApiClient.createApiUrl('download_file')
      const params = url.searchParams
      params.append('id', this.id)
      params.append('thumbnail', 1)
      params.append('attach_file_type', 9)
      return url.toString()
    },
  },
  methods: {
    /**
     * 詳細リンククリック時処理
     */
    $_onClickDetail: function () {
      /**
       * 詳細クリックイベント
       * @param {Number} id 対象ユーザーID
       */
      this.$emit('detail-click', this.id)
    },
  },
}
</script>

<style lang="scss" scoped>
.card-user-small {
  max-width: 15rem;
  display: grid;
  // 1行目: ユーザー名 と 詳細リンク / 2行目: 表示項目の値
  grid-template-columns: minmax(0, 1fr) max-content;
  align-items: center;
  column-gap: 32px;
  row-gap: 2px;
  font-size: $font-size-middle;
  padding: 4px 8px;
  overflow: hidden;
  user-select: none;
}

.item-block {
  grid-column: 1 / -1;
  padding-left: 32px;
}

.info-block {
  display: grid;
  grid-template-columns: 24px minmax(0, 1fr);
  justify-items: start;
  align-items: center;
  column-gap: 8px;

  .profile-icon {
    width: 24px;
    height: 24px;
    border-radius: 50%;
  }

  .user-name {
    max-width: 100%;
    overflow-x: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }
}

.detail-block {
  height: 100%;
  display: flex;
  justify-content: flex-end;
  align-items: center;
}

.detail-link {
  color: #006d30;
  cursor: pointer;

  &:hover {
    text-decoration: underline;
  }
}
</style>
